import { Component, Input, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { ComputeService } from '../services/compute.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { ActivatedRoute, Params } from '@angular/router';
import { storageConverterRender } from '../../../dataprotection/dataprotection-common/common-renderers';
import { NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { RefreshSharedService } from '../../../../refresh-shared-service';
import { setVcdRedirectUrlCookie } from '../../../../../common/utils/utils';

@Component({
  selector: 'vm',
  providers: [
    ComputeService, TranslateService
  ],
  styles: [require('./vm.scss')],
  template: require('./vm.html')
})
export default class Vm implements OnChanges {
  private jsonData: any;
  private vmIdFromRoute: any;
  private subscription: Subscription;
  private isEditVmPopupVisible: boolean = false;
  private isDeleteVmPopupVisible: boolean = false;
  private isEmptyEntity: boolean = false;
  private isBusy: boolean = false;
  private vmData: any;
  private vmSSOURL: string;
  private rsService: RefreshSharedService;
  private refreshSubscription: Subscription;
  private currentClassName: string = '';

  constructor(public computeService: ComputeService,
              private translateService: TranslateService, 
              private route: ActivatedRoute,
              private rss: RefreshSharedService) {
  translateService.use(GlobalVariables.LOCALE);
        this.rsService = rss;
        this.currentClassName = 'Vm';  
  }

  ngOnInit() {
      this.refreshSubscription = this.rsService.getRefreshParam()
      .subscribe (
      item => {
          this.handleEmittedValues(item);
      });
      this.route.params.forEach((params: Params) => {
          this.vmIdFromRoute = params['id4'];
          this.rsService.setParam({
                'loadedComponent': this.currentClassName,
                'detailPageIDName': params['id4'],
                'shouldReloadInventoryTree': true
            });
          this.getVmDetails();
      });
  }
  
  handleEmittedValues(item) {
        if (item.loadedComponent === this.currentClassName) {
            this.jsonData = [];
            this.getVmDetails();
        }
  }

  ngOnChanges(changes) {
  }

  ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
      this.rsService.resetParam();
      if (this.refreshSubscription) {
          this.refreshSubscription.unsubscribe();
      }
  }


  onEditVm = ($event) => {
    this.isEditVmPopupVisible = true;
  }
  onDeleteVm = ($event) => {
    this.isDeleteVmPopupVisible = true;
  }

  getVmDetails() {
    this.vmData = {
        'name': '-',
        'hostName': '-',
        'status': '-',
        'guestOs': '-',
        'vAppName': '-',
        'creationUser': '-',
        'numberOfCpus': '-',
        'computerName': '-',
        'memoryMB': ''
      };
      this.vmData.memoryMB = storageConverterRender(0, 'MB');
      this.isBusy = true;
    if (this.vmIdFromRoute && this.vmIdFromRoute !== '') {
      this.subscription = this.computeService.getVmDetails(this.vmIdFromRoute)
        .subscribe(
          res => {
            this.jsonData = res[0];
            this.isEmptyEntity = this.checkIfEmptyEntity(res);
            if (this.jsonData) {
              this.vmData.creationUser = this.jsonData.hasOwnProperty('creationUser') ? this.jsonData.creationUser : '-';

              if (this.jsonData.vcd) {
                let vcd = this.jsonData.vcd;
                this.vmData.name = vcd.hasOwnProperty('name') ? vcd.name : '-';
                this.vmData.hostName = vcd.hasOwnProperty('hostName') ? vcd.hostName : '-';
                this.vmData.status = vcd.hasOwnProperty('status') ? vcd.status : '-';
                this.vmData.guestOs = vcd.hasOwnProperty('guestOs') ? vcd.guestOs : '-';
                this.vmData.vAppName = vcd.hasOwnProperty('vAppName') ? vcd.vAppName : '-';
                this.vmData.numberOfCpus = vcd.hasOwnProperty('numberOfCpus') ? vcd.numberOfCpus : '-';
                this.vmData.computerName = vcd.hasOwnProperty('computerName') ? vcd.computerName : '-';
                if (vcd.hasOwnProperty('memoryMB')) {
                  this.vmData.memoryMB = storageConverterRender(vcd.memoryMB, 'MB');
                }
              }
              this.setVmSSOURL(this.jsonData.orgName, this.jsonData.vcd.vAppId);
            }
            this.isBusy = false;
          },
          error => {
            this.isBusy = false;
            this.logError(error, 'get vm details');
          },
          () => this.logOperationCompleted('get vm details')
        );
    } else {
      this.logError('Could not get vm id from the route');
    }
  }

  checkIfEmptyEntity(restResult): boolean {
    return (restResult && restResult.constructor === Array && restResult.length === 0) ? true : false;
  }

  logError(error, origin: String = '') {
    console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
  }

  logOperationCompleted(msg: string) {
    console.log('Operation Completed: ', msg);
  }

  setVmSSOURL(orgName: string, vappId: string) {
    if (!orgName || orgName === '') {
      return;
    }

    // vapp id is in the format of "vapp-{vapp-id}". We need only {vapp-id} for the SSO.
    let index = vappId.indexOf('-');
    vappId = vappId.substring(index + 1);
    let url = document.createElement('a');
    url.href = window.location.href;
    this.vmSSOURL = url.protocol + '//' + url.host + '/compute/cloud/org/' + orgName.toLowerCase()
        + '/#/vmList?vapp=' + vappId;
  }

    onMangeInVcd = ($event) => {
        if (this.vmSSOURL) {
            let orgName = this.jsonData.orgName;
            setVcdRedirectUrlCookie(orgName, this.vmSSOURL);
            window.open(this.vmSSOURL, '_blank');
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/vm/vm.component.ts